import React from "react";
import FormikDialog from "./FormikDialog";



function ModuleForm(props) {
  const {
    dataRef,
    onClose,
    isOpen,
    fieldList,
    onSubmitForm,
    selectedData,
    headline,
    validationSchema,
    prefix,
    uploadImage,
    previewComplements,
    previewProps,
    childrenPos,
    children,
    pushMessageToSnackbar
  } = props;

  const isLoading = false;

  return (
    <div>
      <FormikDialog
        ref={dataRef}
        open={isOpen}
        onClose={onClose}
        loading={isLoading}
        onFormSubmit={onSubmitForm}
        fieldList={fieldList}
        hideBackdrop
        headline={headline}
        selectedData={selectedData}
        validationSchema={validationSchema}
        prefix={prefix}
        uploadImage={uploadImage}
        previewComplements={previewComplements}
        previewProps={previewProps}
        childrenPos={childrenPos}
      >
        {
          childrenPos && ['endForm', 'startForm'].includes(childrenPos) && (children)
        }
      </FormikDialog>
    </div>
  );
}

export default ModuleForm;
